var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAplicaIaLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 280",
    width: 880,
    height: 280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon",
    x1: 640,
    y1: 0,
    x2: 790,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A78BFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neonbar",
    x1: 116,
    y1: 176,
    x2: 164,
    y2: 176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#22D3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A78BFA"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 280,
    rx: 24,
    fill: "#0B0F1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 98 212 L 137 118",
    stroke: "#E8ECF4",
    strokeWidth: 13,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143 118 L 182 212",
    stroke: "#E8ECF4",
    strokeWidth: 13,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 176,
    x2: 164,
    y2: 176,
    stroke: "url(#neonbar)",
    strokeWidth: 13,
    strokeLinecap: "round",
    filter: "url(#glow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 96,
    r: 10,
    fill: "#22D3EE",
    filter: "url(#glow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Segoe UI','DejaVu Sans',Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 155,
    fontSize: 72,
    fontWeight: 600,
    letterSpacing: 6,
    fill: "#E8ECF4"
  }, "APLICA ", /*#__PURE__*/React.createElement("tspan", {
    fill: "url(#neon)"
  }, "IA")), /*#__PURE__*/React.createElement("text", {
    x: 234,
    y: 198,
    fontSize: 19,
    fontWeight: 400,
    letterSpacing: 9,
    fill: "#8A93A6"
  }, "INTELIG\xCANCIA ARTIFICIAL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAplicaIaLogoHorizontal);
export default __webpack_public_path__ + "static/media/aplica-ia-logo-horizontal.e96144a1d636fa1a4a0acf2100b7747a.svg";
export { ForwardRef as ReactComponent };